import React from 'react'
import CustomerHeader from '../sections/CustomerHeader'
import CustomerFooter from '../sections/CustomerFooter'
import InstallPrompt from '../../app/components/InstallPrompt'


function AppLayout({children}) {
    return (
        
        <div className="main" >
            <InstallPrompt/>
            <CustomerHeader />
                <div className='mb-5'>
                {children}
                </div>
               
            <CustomerFooter />
        </div>
    )
}

export default AppLayout